export enum LogoutReasons {
  logoutReason = 'logoutReason',
  userNotFound = 'User not found in licensing',
  distributor = 'Distributor users not currently supported.',
}
